module.exports = __webpack_public_path__ + "media/trubadur.19d70717.mp4";